import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { isMcpFlow } from '@frontend/web/hooks/useMcpFlow';
import { createFileRoute, redirect } from '@frontend/web/utils/router';
import { handleRedirectBeforeLoad } from '@frontend/web/utils/routing/handleRedirectBeforeLoad';
import { lazy, Suspense } from 'react';

const LazyAppWithProviders = lazy(() =>
  import('./-app-shell').then(({ AppWithProviders }) => ({ default: AppWithProviders })),
);

const AppRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyAppWithProviders />
  </Suspense>
);

export const Route = createFileRoute('/app')({
  beforeLoad: async ({ context, location }) => {
    if (isMcpFlow()) {
      throw redirect({
        to: '/signup/mcp/complete',
      });
    }

    handleRedirectBeforeLoad({ context, location });
  },
  component: AppRouteComponent,
});
